// import { TResetToken, TSignin } from 'models/Authen/sign.model';
import axios from 'axios';
import api from 'src/configs/api';
import { TForgotPassword, TResetPassword, TResetToken, TSignin, TSignInResponse } from 'src/types/Authens/signin.model';
import queryString from 'query-string';
import { TBaseResponse } from 'src/types/Commons/filter.model';

const prefix = 'api/user';
export async function signup(params: TSignin) {
  const res = await api.post('users/signup', params);
  return res.data;
}
export async function signinAPI(params:TSignin){
 
  const res =await api.post("api/Authen/sign-in",params) 
  return res.data as TBaseResponse<TSignInResponse>;
}

export async function signin(params: TSignin) {
  const formValue = {
    ...params,
    ...{
      grant_type: 'password',
      scope: `openid ${process.env.REACT_APP_B2C_CLIENT_ID} offline_access`,
      client_id: process.env.REACT_APP_B2C_CLIENT_ID
    }
  };

  const res = await axios({
    method: 'post',
    url: process.env.REACT_APP_B2C_URL,
    params: formValue,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });

  return res.data;
}

export async function refreshToken(refreshToken: string) {
  const formValue = {
    ...{
      grant_type: 'refresh_token',
      response_type: 'id_token',
      client_id: process.env.REACT_APP_B2C_CLIENT_ID,
      resource: process.env.REACT_APP_B2C_CLIENT_ID,
      refresh_token: refreshToken
    }
  };

  const res = await axios({
    method: 'post',
    url: process.env.REACT_APP_B2C_REFESH_TOKEN_URL,
    data: queryString.stringify(formValue),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });

  return res.data;
}

export async function resetPassword(param: TResetToken) {
  const res = await api.post('account/resetpassword', param);
  return res.data;
}
export async function resetDefaultPassword(param: TResetPassword) {
  const res = await api.post(`${prefix}/password-reset`, param);
  return res.data;
}
export async function forgotPassword(email: string) {
  const res = await api.post(`${prefix}/forgot-password`, { email: email });
  return res.data;
}

export const getProfile = async () => {
  const res = await api.get(`${prefix}/profile`);
  return res.data;
};

export async function verifyTokenUpdatePassword(param: TForgotPassword) {
  const res = await api.post(`${prefix}/verify-token`, param);
  return res.data;
}
